module.exports = __webpack_public_path__ + "img/RapidExperimentingWithJobShadow.e6c76f9c.jpg";